export const COINGECKO_MARKETS_TTL_MS = 10 * 60 * 1000;
export const COINGECKO_LAZY_TTL_MS = 15 * 60 * 1000;
export const COINGECKO_SEARCH_TTL_MS = 5 * 60 * 1000;

export function normalizeCoinIds(ids: string[]): string[] {
  return Array.from(
    new Set(ids.map((id) => id.trim().toLowerCase()).filter(Boolean))
  ).sort();
}

export function buildMarketsRequestKey(ids: string[]): string {
  const normalized = normalizeCoinIds(ids);
  return `markets:${normalized.join(',')}`;
}

export function buildSearchResourceKey(query: string): string {
  return `search:${query.trim().toLowerCase()}`;
}
